import { render, staticRenderFns } from "./busca.vue?vue&type=template&id=efe3ba0c"
import script from "./busca.vue?vue&type=script&lang=ts"
export * from "./busca.vue?vue&type=script&lang=ts"
import style0 from "./busca.vue?vue&type=style&index=0&id=efe3ba0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports